import { libClearIntstr, libFormatDate } from 'src/toolkit';


export type TAccountPassportFile = {
	name: string;
	path: string;
};

export type TAccountPassportFileRequest = Array<File | string>;

export type TAccountPassport = {
	lastName: string;
	firstName: string;
  thirdName: string;
  passportNumber: string;
  departmentCode: string;
  birthday: string;
  issueDate: string;
  issuedBy: string;
  registrationAddress: string;
  bornPlace: string;
  files: TAccountPassportFile[];
	createdAt: string;
	updatedAt: string;
};

export type TAccountPassportBodyRequest = {
	lastName?: string;
	firstName?: string;
  thirdName?: string;
  passportNumber?: string;
  departmentCode?: string;
  birthday?: string;
  issueDate?: string;
  issuedBy?: string;
  registrationAddress?: string;
  bornPlace?: string;
};

export type TAccountPassportResponse = {
	last_name: string;
	first_name: string;
  third_name: string;
  passport_number: string;
  department_code: string;
  birthday: string;
  issue_date: string;
  issued_by: string;
  registration_address: string;
  born_place: string;
  files: TAccountPassportFile[];
	created_at: string;
	updated_at: string;
};

export type TAccountPassportRequest = Omit<TAccountPassportResponse, 'files' | 'created_at' | 'updated_at'>;

export type TAccountPassportPayload = {
	data: TAccountPassportBodyRequest;
	files: TAccountPassportFileRequest;
};

export function adaptAccountPassportFromResponse(data: TAccountPassportResponse): TAccountPassport {
	const {
		last_name: lastName = '',
		first_name: firstName = '',
		third_name: thirdName = '',
		passport_number: passportNumber = '',
		department_code: departmentCode = '',
		birthday: birthdayRaw,
		issue_date: issueDateRaw,
		issued_by: issuedBy = '',
		registration_address: registrationAddress = '',
		born_place: bornPlace = '',
		files = [],
		created_at: createdAt,
		updated_at: updatedAt,
	} = data;

	const birthday = birthdayRaw ? libFormatDate(birthdayRaw, { template: 'yyyy-MM-dd' }) : '';
	const issueDate = issueDateRaw ? libFormatDate(issueDateRaw, { template: 'yyyy-MM-dd' }) : '';

	return {
		lastName,
		firstName,
		thirdName,
		passportNumber,
		departmentCode,
		birthday,
		issueDate,
		issuedBy,
		registrationAddress,
		bornPlace,
		files,
		createdAt,
		updatedAt,
	};
}

export function adaptAccountPassportToRequest(data: TAccountPassportBodyRequest): TAccountPassportRequest {
	const {
		lastName = '',
		firstName = '',
		thirdName = '',
		passportNumber = '',
		departmentCode = '',
		birthday = '',
		issueDate = '',
		issuedBy = '',
		registrationAddress = '',
		bornPlace = '',
	} = data;

	return {
		last_name: lastName,
		first_name: firstName,
		third_name: thirdName,
		passport_number: libClearIntstr(passportNumber),
		department_code: libClearIntstr(departmentCode),
		birthday,
		issue_date: issueDate,
		issued_by: issuedBy,
		registration_address: registrationAddress,
		born_place: bornPlace,
	};
}

